import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useHashView } from './useHashView';
import { IN_SCOPE_PATH_FOR, isPathInScope, parseShareUrl } from './shareLinkConfig';

// When a hashed view is active, the user is locked to the single shared resource.
// This wraps the normal route Switch and redirects any attempt to navigate
// elsewhere back to the in-scope path. The /share/:hash redemption route is
// allowed through so redemption can complete on a fresh page load.
export default function HashViewGuard({ children }) {
  const { active, scope } = useHashView();
  const location = useLocation();

  if (!active) return children;

  // Allow the redemption route to render so it can complete its redirect.
  if (parseShareUrl(location)) return children;

  if (scope && !isPathInScope(location.pathname, scope)) {
    return <Redirect to={IN_SCOPE_PATH_FOR(scope)} />;
  }

  return children;
}
